import { render, staticRenderFns } from "./VoucherPage.vue?vue&type=template&id=464c2ca8"
import script from "./VoucherPage.vue?vue&type=script&lang=js"
export * from "./VoucherPage.vue?vue&type=script&lang=js"
import style0 from "./VoucherPage.vue?vue&type=style&index=0&id=464c2ca8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports